<template>
  <div>
    <div class="search">
      <form action="/">
      <van-search v-model="value" placeholder="请输入搜索内容" @search="onSearch" />
    </form>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-row class="list" v-for="item in eventlist" :key="item.id">
          <van-col span="24" class="list-item" @click="todetail(item)">
            <div class="img">
              <img :src="item.thumb" alt="" />
              <div class="mask">
                {{
                  item.status === "Enrolling"
                    ? "报名中"
                    : item.status === "NotStarted"
                    ? "未开始"
                    : item.status === "Ended"
                    ? "已结束"
                    : "已结束"
                }}
              </div>
            </div>
            <div class="content">
              <p class="title">
                {{ item.title }}
              </p>
              <p class="time">
                活动时间：{{ item.startTime }}
                <span v-if="item.startTime">-</span> {{ item.endTime }}
                <span v-if="!item.startTime">暂未开始</span>
              </p>
            </div>
          </van-col>
        </van-row>
      </van-list>
    </van-pull-refresh>
    <van-row :gutter="15" class="btns">
      <van-col :span="12">
        <van-button
          :class="active == 1 ? 'active' : ''"
          round
          @click="select(1)"
          >活动列表</van-button
        >
      </van-col>
      <van-col :span="12">
        <van-button
          round
          :class="active == 2 ? 'active' : ''"
          @click="select(2)"
          >个人中心</van-button
        >
      </van-col>
    </van-row>
  </div>
</template>
<script>
import { Toast } from "vant";
import { eventlist } from "@/api/home";
export default {
  data() {
    return {
      value: null,
      active: 1,
      loading: false,
      finished: false,
      refreshing: false,
      eventlist: [],
      limt: 3,
      page: 1,
      count: 0,
    };
  },
  methods: {
    select(num) {
      // console.log(num);
      this.active = num;
      if (num == 1) {
        // this.$router.push({
        //   path: "/home",
        // });
      } else {
        this.$router.push({
          path: "/user",
        });
      }
    },
    todetail(item) {
      this.$router.push({
        path: "/activeinfo",
        query: {
          id: item.id,
        },
      });
    },
    // getlist() {
    //   eventlist().then((res) => {
    //     // console.log(res);
    //     this.eventlist = res.list;
    //   });
    // },
    onLoad() {
      if (!this.finished) {
        const route = this.$route
        eventlist({ page: this.page, limit: this.limt,title:this.value },route)
          .then((res) => {
            this.eventlist.push(...res.list);
            this.count = res.count;
            this.refreshing = false;
            if (this.eventlist.length >= this.count) {
              this.finished = true;
              this.refreshing = false;
              return;
            }
            this.page++;
            // console.log(this.eventlist);

            // Toast("刷新成功");
            this.loading = false;
          })
          .catch((e) => {
            console.log(e.message);
            Toast("加载失败");
            this.loading = false;
            this.refreshing = false;
            this.finished = true;
          });
      }
    },
    onRefresh() {
      this.page = 1;
      this.eventlist = [];
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      // this.loading = true;
      this.onLoad();
    },
    onSearch(){
      // console.log(this.value)
      this.onRefresh()
    }
  },
  created() {
    // this.getlist();
  },
};
</script>
<style lang="scss" scoped>
.search {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: #fff;
  padding: 5px 0;
  width: 100%;

  .van-search__content {
    border-radius: 20px;
  }
}
.van-list {
  margin-bottom: 80px;
  margin-top: 65px;
}
.list {
  padding: 15px 18px;
  border-top: 10px solid #f6f6f6;
  .list-item {
    box-shadow: 1px 0px 7px 2px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    margin-bottom: 10px;
    .img {
      position: relative;
      height: 180px;
      img {
        height: 180px;
        width: 100%;
      }
      .mask {
        position: absolute;
        bottom: 0px;
        left: 0;
        width: 100%;
        height: 40px;
        background: rgba(0, 0, 0, 0.3);
        color: #fff;
        font-size: 14px;
        line-height: 40px;
      }
    }
    .content {
      padding: 15px 20px;
      padding-right: 0;
      text-align: left;
      .title {
        font-size: 16px;
        font-weight: bold;
      }
      .time {
        font-size: 14px;

        margin-top: 10px;
      }
    }
  }
  // .list-item:last-child {
  //   margin-bottom: 80px;
  // }
}
.btns {
  width: 100%;
  padding: 0px 18px 20px;
  position: fixed;
  bottom: 0px;
  left: 0;
  z-index: 999;
  box-sizing: border-box;
  // background: #fff;
  .van-button {
    width: 100%;
    background-color: #fff;
    border-color: #2553e2;
    color: #2553e2;
  }
  .active {
    background-color: #2553e2;
    color: #fff;
  }
}
</style>